import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";

import { SliceKeys, tablePaginationInitialValue } from "@sso/constant";
import { RootState } from "@sso/store";
import { SearchColumn } from "@sso/types";
import { getTableSortColumn, queryBuilder } from "@sso/utils";

export const BannedIPSlice = createSlice({
  name: SliceKeys.BANNED_IP,
  initialState: { pagination: tablePaginationInitialValue },
  reducers: {
    setBannedIPPageSize: (state, action: PayloadAction<number>) => {
      state.pagination.pageIndex = tablePaginationInitialValue.pageIndex;
      state.pagination.pageSize = action.payload;
    },
    setBannedIPPageIndex: (state, action: PayloadAction<number>) => {
      state.pagination.pageIndex = action.payload;
    },
    setBannedIPSearchColumn: (state, action: PayloadAction<SearchColumn>) => {
      state.pagination.pageIndex = tablePaginationInitialValue.pageIndex;
      state.pagination.search[action.payload.column] = action.payload;
    },
    clearBannedIPSearchColumn: (state, action: PayloadAction<string>) => {
      const { [action.payload]: deleteItem, ...otherSearchItems } = state.pagination.search;
      state.pagination.search = otherSearchItems;
      state.pagination.pageIndex = tablePaginationInitialValue.pageIndex;
    },
    setBannedIPSortColumn: (state, action: PayloadAction<string>) => {
      const { column, type } = state.pagination.sort;
      state.pagination.sort = getTableSortColumn(column, action.payload, type);
    },
  },
});

export const {
  setBannedIPPageIndex,
  setBannedIPPageSize,
  setBannedIPSearchColumn,
  setBannedIPSortColumn,
  clearBannedIPSearchColumn,
} = BannedIPSlice.actions;

export const selectBannedIPPagination = createSelector(
  (state: RootState) => state.bannedIP.pagination,
  ({ pageSize, totalPages, pageIndex, sort, search }) => ({
    pageSize: { action: setBannedIPPageSize, value: pageSize },
    pagination: {
      totalPages,
      pageIndex,
      action: setBannedIPPageIndex,
    },
    sort,
    search: { object: search, onChange: setBannedIPSearchColumn, onClear: clearBannedIPSearchColumn },
  }),
);
export const selectBannedIPQuery = createSelector(
  (state: RootState) => state.bannedIP.pagination,
  ({ pageSize, pageIndex, search, sort }) => queryBuilder(pageSize, pageIndex, search, sort),
);

export default BannedIPSlice.reducer;
